module.exports = __webpack_public_path__ + "img/green_028.f4d8669c.png";